/* eslint-disable no-return-assign */
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Grid } from '@material-ui/core/'
import { useDebouncedCallback } from 'use-debounce'
import api from '../../../../api/auth'
import apiStory from '../../../../api/stoty'
import { setStep5, setStep4, setStep3, setStep2, setStep1, createStory } from '../../../../modules/story/actions'
import { Button, DialogModal, Notification } from '../../../../components/UI/'
import tellStoryBtn from '../../../../assetss/img/newTellStory.png'
import tellStoryActive from '../../../../assetss/img/newTellMeActive.png'
import { TagInput } from './components/index'
import { googleId } from '../../../../modules/session/actions'
import './index.scss'

const Step5 = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { story } = useSelector(state => state)
  const [open, setOpen] = useState(false)
  const [openAlert, setOpenAlert] = useState()
  const [response, setResponse] = useState()
  const { step4 } = useSelector(({ story }) => story)
  const { user } = useSelector(({ session }) => session)
  const [lastValue, setLastValue] = useState('')
  const [loading, setLoading] = useState(false)

  const goTo = path => history.push(path)
  const onCloseHandler = () => {
    setOpen(prev => !prev)
    if (open) {
      goTo('/')
    }
  }

  const onSignUp = () => {
    api.loginGuoogle().then(e => {
      dispatch(googleId(e?.data?.url))
      if (e?.data?.url) {
        window.location.href = e?.data?.url
      }
    })
  }

  const onNext = () => {
    const newHashtags = lastValue?.length > 1 ? `${step4?.hashtags || ''} ${lastValue}` : step4?.hashtags
    if (!newHashtags) {
      if (!user?.user?.uuid) {
        dispatch(setStep4({ hashtags: newHashtags }))
        onSignUp()
        setLoading(false)
      } else {
        dispatch(setStep4({ hashtags: newHashtags }))
        const data = {
          ...story.step1,
          ...story.step2,
          ...story.step4,
          ...story.step5,
          accessKey: user?.accessKey,
          hashtags: newHashtags,
          imageUuid: story?.step3?.imageUuid,
        }
        dispatch(createStory(data))
          .then(res => {
            if (!res?.data?.error?.message) {
              onCloseHandler()
              dispatch(setStep1(null))
              dispatch(setStep2(null))
              dispatch(setStep3(null))
              dispatch(setStep4(null))
              dispatch(setStep5(null))
              setLoading(false)
            } else {
              setOpenAlert(res?.data?.error?.message)
              setLoading(false)
            }
            setResponse(res?.data)
          })
      }
    } else {
      if (!user?.user?.uuid) {
        dispatch(setStep4({ hashtags: newHashtags }))
        onSignUp()
        setLoading(false)
      } else {
        dispatch(setStep4({ hashtags: newHashtags }))

        const data = {
          ...story.step1,
          ...story.step2,
          ...story.step4,
          ...story.step5,
          accessKey: user?.accessKey,
          hashtags: newHashtags,
          imageUuid: story?.step3?.imageUuid,
        }

        dispatch(createStory(data))
          .then(res => {
            if (!res?.data?.error?.message) {
              setLoading(false)
              onCloseHandler()
              dispatch(setStep1(null))
              dispatch(setStep2(null))
              dispatch(setStep3(null))
              dispatch(setStep4(null))
              dispatch(setStep5(null))
            } else {
              setLoading(false)
              setOpenAlert(res?.data?.error?.message)
            }
            setResponse(res?.data)
          })
      }
    }
  }

  const onChangeValue = items => dispatch(setStep4({ hashtags: items?.join(' ') }))

  const debounced = useDebouncedCallback(
    () => {
      onNext()
    }, 1000,
  )

  return (
    <>
      <Notification text={openAlert} open={openAlert} type='error' onClose={setOpenAlert} />
      <DialogModal
        open={open}
        onClose={onCloseHandler}
        height='100%'
        maxHeight='284px'
        closeBtn
      >
        <Grid container direction='column' alignItems='center' justify='space-between' className='createModal'>
          <Typography className='titleModalSucsses'>You story has been <br /> successfully posted!</Typography>
          <Button onClick={() => goTo(`/story/${response?.story?.uuid}/newStory`)} className='goStoryVievBtn'>View my story</Button>
          <Button onClick={() => goTo('/')} className='goHomeVievBtn'>Go to home page</Button>
        </Grid>
      </DialogModal>
      <Grid className='boxStep3' container direction='column'>
        <Typography className='subTitle'>
          Write your story
        </Typography>
        <Typography className='stepTitle'>
          Add hashtags to your story
        </Typography>
        <TagInput setOpenAlert={setOpenAlert} defaultValue={step4?.hashtags?.length ? step4?.hashtags?.split(' ') : []} onChangeValue={onChangeValue} setLastValue={setLastValue} />
        <Grid className='btnStepFive'>
          <Button className='prevBtnFiveStep' onClick={() => goTo('/new-story/step/4')}>
            Previous step
          </Button>
          <img
            onMouseDown={e => e.target.src = tellStoryActive}
            onClick={e => {
              if (loading) return
              e.target.src = tellStoryBtn
              debounced()
              setLoading(true)
            }}
            className='tellBtnNewStory'
            src={tellStoryBtn}
            alt='tellBtn'
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Step5
